<!--
 * @Author: your name
 * @Date: 2021-11-25 14:55:54
 * @LastEditTime: 2022-10-10 16:29:13
-->
<template>
  <div class="pages">
    <h1 class="title">隐私政策-中国</h1>
    <div>
      <p class="sub_text btd">发布日期：2022年1月20日</p>
      <p class="sub_text btd">生效日期：2022年1月27日</p>
      <p class="sub_text">
        本政策适用于极兔速递有限公司、极兔国际物流有限公司及其直属分支机构、加盟合作伙伴等（以下简称“极兔”或“我们”）。我们一直非常重视用户的隐私和个人信息保护，您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关个人信息。我们将会通过本隐私政策向您说明我们在提供产品与/或服务时如何收集、存储、使用、共享、转让、公开披露这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。如果您对本隐私政策有任何疑问、意见或建议，可通过极兔在线客服或电子邮件、客服电话等方式与我们联系，一般情况下，我们将<span
          class="fontb"
          >在十五个工作日</span
        >内回复。
      </p>
      <p class="sub_text">我们的地址：<span class="fontb">上海市青浦区华新镇华隆路1777号；</span></p>
      <p class="sub_text">官方网站地址：<a  class="fontue">https://www.jtexpress.cn</a>；</p>
      <p class="sub_text">邮件：<a  class="fontue">jtservice@jtexpress.com</a>；</p>
      <p class="sub_text">客服电话：<span class="fontb">956025</span></p>
      <p class="sub_text">
        如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案，向您所在国家的监管部门进行投诉或举报，例如中国的网信、电信、公安及工商等监管部门。
      </p>
      <p class="sub_text">
        本隐私政策与您所使用的极兔物流服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，请务必仔细阅读并理解本政策。一旦您开始使用或在我们更新本隐私政策后继续使用我们的产品与/或服务，即表示您已充分理解并同意本政策(含更新版本)内容，并且同意我们按照本政策的约定处理您的个人信息。如您不同意本政策的任何条款，您应立即停止使用极兔的产品与/或服务。
      </p>
      <p class="sub_text">当您同意隐私协议后仍然可以通过以下途径再次浏览:</p>
      <p class="sub_text">1.访问官网点击底部<span class="fontb">“隐私政策”</span>；</p>
      <p class="sub_text">2.小程序中通过<span class="fontb">“我的”-“隐私政策”。</span></p>
      <p class="sub_text">本政策将帮助您了解以下内容：</p>
      <p class="sub_text"><span class="fontb">一、我们如何收集信息</span></p>
      <p class="sub_text"><span class="fontb">二、我们如何使用Cookie和同类技术</span></p>
      <p class="sub_text"><span class="fontb">三、我们如何存储和保护您的个人信息</span></p>
      <p class="sub_text"><span class="fontb">四、我们如何使用信息</span></p>
      <p class="sub_text"><span class="fontb">五、我们如何对外提供信息</span></p>
      <p class="sub_text"><span class="fontb">六、您如何访问和管理自己的信息</span></p>
      <p class="sub_text"><span class="fontb">七、我们如何处理儿童的个人信息</span></p>
      <p class="sub_text"><span class="fontb">八、您的个人信息如何在全球范围转移</span></p>
      <p class="sub_text"><span class="fontb">九、本指引的修订及更新</span></p>
      <p class="sub_text"><span class="fontb">十、其他事宜</span></p>
      <p class="sub_text"><span class="fontb">一、我们如何收集您的个人信息</span></p>
      <p class="sub_text"><span class="fontb">1.名词解释</span></p>
      <p class="sub_text">1）个人信息：</p>
      <p class="sub_text">
        个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。我们收集个人信息包括<span class="fontb"
          >个人基本资料（个人姓名、住址、寄递地址、个人电话号码、电子邮件地址）、身份证号码、用户名、账号密码、工作单位、快件路由信息、物流单号、精准定位信息、交易信息</span
        >。
      </p>
      <p class="sub_text">2）个人敏感信息：</p>
      <p class="sub_text">
        敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。本政策中涉及的个人敏感信息，将采用加粗字体突出显示。我们收集个人敏感信息包括<span
          class="fontb"
          >身份证号码、精准定位信息、交易信息</span
        >。
      </p>
      <p class="sub_text">3）快递物流服务：</p>
      <p class="sub_text">
        从接收用户订单开始到将物品送到用户手中为止所发生的所有服务活动，保证用户的物品在顾客要求的时间内准时送达，包括下单、收件、封装、中转、派件、售后等服务。
      </p>
      <p class="sub_text">4）寄递用户</p>
      <p class="sub_text">向快递物流服务运营者获取快递物流服务的个人或组织，包括寄件用户和收件用户。</p>
      <p class="sub_text">5）快件路由信息</p>
      <p class="sub_text">
        快递物流服务运营者记录快件在寄递主要环节的流转信息，并据此向用户提供的快件查询信息，流转信息包括处理时间、处理场所、处理状态和处理结果等
      </p>
      <p class="sub_text"><span class="fontb">2、实现业务功能所必须收集的场景</span></p>
      <p class="sub_text">我们可能会收集、保存和使用您有关的信息才能实现下述功能。如果您不提供相关信息，您将无法享受相关的服务。这些功能包括：</p>
      <p class="sub_text">1）寄递用户注册及实名制</p>
      <p class="sub_text">
        我们将微信及百度小程序作为寄递用户注册入口。您可以通过点击微信及百度小程序中的用户头像授权我们使用<span class="fontb">微信昵称和头像</span>。根据<span
          class="fontb"
          >《中华人民共和国网络安全法》</span
        >我们将收集您的<span class="fontb">手机号码</span>，当您在微信及百度小程序中可以选择输入手机号注册或登录，也可以通过微信及百度账号授权进行快捷登录。
      </p>
      <p class="sub_text">
        根据<span class="fontb">《邮件快件实名收寄管理办法》以及《常见类型移动互联网应用程序必要个人信息范围规定》</span>我们将收集您的<span class="fontb"
          >寄件人姓名、证件类型和号码</span
        >等身份信息作为实名登记信息。实名制的信息我们将<span class="fontb">上报至国家实名收寄信息监管平台</span>。
      </p>
      <p class="sub_text">2）提供物流服务所必须</p>
      <p class="sub_text">在您下单寄件或您的信息作为收件人被提供时，我们或通过授权的业务合作伙伴收集您的以下信息：</p>
      <p class="sub_text">
        当您使用国内寄递业务时，我们会收集<span class="fontb"
          >寄件人及收件人的姓名（收件人可为名称）、地址、联系方式和寄递物品的名称、性质、数量（统称“运单信息”）</span
        >，用于提交订单、生成物流运单、收件、分拣、仓储、运输以及派送货件；根据<span class="fontb">《邮件快件实名收寄管理办法》</span>在收件时查验寄件人的<span
          class="fontb"
          >有效身份证件</span
        >，登记相关身份信息，留存有效<span class="fontb">身份证件复印件</span>。如寄件人为法人或者其他组织的，将核对、记录<span class="fontb"
          >统一社会信用代码</span
        >，留存法定代表人或者相关负责人的有效身份证件复印件。
      </p>
      <p class="sub_text">
        当您使用国际寄递服务时，根据<span class="fontb">《中华人民共和国海关对进出境快件监督办法》</span>我们还将收集您的<span class="fontb"
          >身份证件信息（包括身份证正反面）</span
        >用于向海关申请办理进出口申报手续。
      </p>
      <p class="sub_text">此外，在为您提供收派服务的过程中，如涉及电话沟通，我们可能会对<span class="fontb">通话内容进行录音</span>，以避免潜在纠纷。</p>
      <p class="sub_text">3）优惠促销活动</p>
      <p class="sub_text">
        您可以选择参与极兔的促销活动，享受订单金额减免、领取赠品等优惠。为实现前述优惠，我们还需要收集与处理您的Union ID、Open
        ID、微信相关信息、模糊地理位置信息等信息数据。
      </p>
      <p class="sub_text">3)支付结算</p>
      <p class="sub_text">
        在您下单后，您可以选择我们的关联方或与合作的第三方支付机构（如支付宝、微信支付以及银联、网联等支付通道，以下称“支付机构”）所提供的支付服务，我们需要将您的<span
          class="fontb"
          >订单号与交易金额信息</span
        >提供给这些支付机构以确认您的支付指令并完成支付。
      </p>
      <p class="sub_text">
        如您为企业用户在申请发票时需提供以下信息：<span class="fontb">发票抬头、纳税人识别号、纳税人电子邮箱、手机号</span
        >；如您为个人/事业单位需要提供以下信息：<span class="fontb">抬头姓名、电子邮箱、手机号</span>。
      </p>
      <p class="sub_text">4）消息推送</p>
      <p class="sub_text">
        在我们使用微信公众号向您推送快件路由信息、支付状态信息、促销优惠活动及其他消息通知信息，为了完成消息推送功能将收集您的<span class="fontb"
          >设备型号和操作系统及版本</span
        >。您可以在微信公众号进行免打扰设置。
      </p>
      <p class="sub_text">5）客服与售后</p>
      <p class="sub_text">
        为确定您的身份，我们的呼叫中心客服和在线客服会使用您的账号信息、运单信息核验您的身份。当您需要我们提供与您的寄件相关的客服与售后服务时，我们将会查询您的<span
          class="fontb"
          >运单信息、货件路由信息</span
        >。
      </p>
      <p class="sub_text">如您要求我们变更派送地址、联系人或联系电话时，在与我们的客服人员沟通时，您有可能需要提供上述信息外的其他信息。</p>
      <p class="sub_text">6）安全风控的需要。</p>
      <p class="sub_text">
        当您浏览、使用微信及百度小程序时，我们会向您收集您的<span class="fontb"
          >OpenID、UnionID、相关设备信息（包括设备品牌、设备型号、操作系统信息）、微信相关信息（包括微信设置的语言、微信版本号）</span
        >进行分析、统计流量并排查可能存在的风险、保护账户安全、协助异常事件的排查。
      </p>
      <p class="sub_text"><span class="fontb">3、实现业务附加功能所收集的场景</span></p>
      <p class="sub_text">1）网点查询功能</p>
      <p class="sub_text">
        为了方便您查询我们的服务网点，并使用导航功能，您可以在微信及百度小程序中授权开启<span class="fontb">地理位置权限</span>，我们将收集您的<span
          class="fontb"
          >地理位置信息</span
        >。
      </p>
      <p class="sub_text">2）地址快填功能</p>
      <p class="sub_text">为了方便您快速填写地址，在微信及百度小程序中除手动输入外，我们还提供了通过定位功能导入及通过OCR对身份证识别导入的方式。</p>
      <p class="sub_text">
        a.在使用定位功能导入时需要您授权开启<span class="fontb">地理位置权限</span>，我们将收集您的<span class="fontb">地理位置信息</span>。
      </p>
      <p class="sub_text">b.在使用OCR对身份证识别导入时需要您授权<span class="fontb">摄像头权限及相册读取权限</span>，我们不会收集您任何信息。</p>
      <p class="sub_text">3）扫码寄件功能</p>
      <p class="sub_text">
        为了简化您寄件过程，我们在微信及百度小程序中还提供扫描寄件功能，在使用该功能时需要您授权<span class="fontb">摄像头权限及相册读取权限</span>。
      </p>
      <p class="sub_text"><span class="fontb">4.我们从第三方获得您个人信息的情形</span></p>
      <p class="sub_text">
        1）在您同意本政策后会通过小程序授权获取您的手机号码，将小程序与我们的账户绑定，这时您可以通过小程序直接登录并使用我们的服务。同样在获得您授权后还会从小程序方共享您的<span
          class="fontb"
          >头像、昵称</span
        >。
      </p>
      <p class="sub_text">
        2）在通过第三方渠道下单寄件时，例如电商平台、快递物流服务受理组织等，收寄人姓名、地址、电话和货件等面单信息由该第三方收集并打印在我们提供的空白模板上。相关数据信息（<span
          class="fontb"
          >收寄件人姓名、地址、货件信息及脱敏后的电话</span
        >）根据合同约定及个人信息保护策略，通过API接口传递给我们，以完成对您的收寄件相关服务
      </p>
      <p class="sub_text">3）如我们从我们的合作伙伴获取您的个人信息，我们将依据与第三方的约定，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</p>
      <p class="sub_text">我们承诺：</p>
      <p class="sub_text">1）我们从第三方间接获取您的个人信息的数量为实现产品业务功能所必需的最少数量。</p>
      <p class="sub_text">
        2）从第三方间接获取您的个人信息时，要求第三方说明个人信息来源，并会对其个人信息来源的合法性进行确认。我们将了解并审慎注意第三方已获得您的个人信息处理的授权同意范围包括使用目的，您是否授权同意转让、共享、公开披露等。我们开展业务所需进行的个人信息处理活动超出该授权同意范围的，将在获取您的个人信息后的合理期限内或处理您的个人信息前，征得您的明示同意。
      </p>
      <p class="sub_text"><span class="fontb">5.征得授权同意的例外情况</span></p>
      <p class="sub_text">您充分知悉，在以下情形中，我们收集、使用个人信息无须征得您的授权同意：</p>
      <p class="sub_text">1）与个人信息控制者履行法律法规规定的义务相关的；</p>
      <p class="sub_text">2）与国家安全、国防安全直接相关的；</p>
      <p class="sub_text">3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p class="sub_text">4）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
      <p class="sub_text">5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到 本人授权同意的；</p>
      <p class="sub_text">6）所涉及的个人信息是个人信息主体自行向社会公众公开的；</p>
      <p class="sub_text">7）根据个人信息主体要求签订和履行合同所必需的；</p>
      <p class="sub_text">8）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开 等渠道；</p>
      <p class="sub_text">9）维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的 故障；</p>
      <p class="sub_text">
        根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
      </p>
      <p class="sub_text"><span class="fontb">二、我们如何使用Cookie和同类技术</span></p>
      <p class="sub_text"><span class="fontb">1.cookie</span></p>
      <p class="sub_text">
        为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好等数据。
      </p>
      <p class="sub_text">
        我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除
        Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。
      </p>
      <p class="sub_text"><span class="fontb">2.Do Not Track（请勿追踪）</span></p>
      <p class="sub_text">
        很多网络浏览器均设有Do Not Track功能，该功能可向网站发布Do Not
        Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了Do Not
        Track，那么我们的所有网站都会尊重您的选择。
      </p>
      <p class="sub_text"><span class="fontb">三、我们如何存储和保护您的个人信息</span></p>
      <p class="sub_text"><span class="fontb">1.我们如何存储您的个人信息</span></p>
      <p class="sub_text">
        我们在中华人民共和国境内在收寄活动收集和产生的个人信息和重要数据<span class="fontb">存储在中华人民共和国境内</span
        >。当涉及跨境寄递业务时，我们会进行数据出境安全自评估及个人信息安全影响评估，对个人信息跨境数据传输进行评估，在满足寄递业务最小化、必要的前提下进行传输，我们会对跨境传输日志进行详细的记录。
      </p>
      <p class="sub_text">
        1）为满足您的查询需要，您的<span class="fontb">运单信息在前台系统将保留三个月的期限</span
        >，您可通过运单上标明的寄件人、收件人手机号或运单号在官网或其他下单的渠道（如微信及百度小程序等）查询货件路由信息，满足该期限后，我们将在前台系统中去除您的运单信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。
      </p>
      <p class="sub_text">
        2）根据<span class="fontb">《快递市场管理办法》</span>您的运单信息将在后台系统保存更长的期限，<span class="fontb">保存期限不少于1年</span>。
      </p>
      <p class="sub_text">3）如果我们终止服务或运营，我们会至少提前三十天通知您，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</p>
      <p class="sub_text">
        4）当您选择注销我们的账户时，我们将对您的权益及信息设置<span class="fontb">三十天的注销删除等待期</span
        >，在提交注销申请后的等待期内可撤销申请，并可通过重新注册复原相关个人账号信息和相关个人服务记录，超过等待期将根据法律法规删除或匿名化处理。
      </p>
      <p class="sub_text"><span class="fontb">2.我们如何保护您的个人信息安全</span></p>
      <p class="sub_text">
        1）为了保障您的信息安全，我们在收集您的信息后，将采取各种合理必要的措施保护您的信息。例如，在技术开发环境当中，我们仅使用经过去标识化处理的信息进行统计分析。我们会将去标识化后的信息与可用于恢复识别个人的信息分开存储，确保在针对去标识化信息的后续处理中不重新识别个人。
      </p>
      <p class="sub_text">
        2）我们会采用符合业界标准的安全防护措施，安全技术解决方案来防止您的信息遭到未经授权的访问、使用、篡改,避免数据的损坏丢失或泄露，包括但不限于：在物理安全上，我们部署了监控系统并严格按照机房管理制度进行访问控制；在技术上，我们提供的应用服务使用全站https传输协议，采用权威CA机构颁发的TLS/SSL证书加密传输，保证数据传输的机密性和完整性；
      </p>
      <p class="sub_text">
        3）在管理上，我们通过建立信息资产密级划分、标识及处置管理制度和信息资产分级分类指引来规范信息和数据的分类存储和使用，对于所有员工录用前我们都会经过背景调查、签署保密协议、定期开展信息与隐私保护培训和意识宣贯。
      </p>
      <p class="sub_text">
        4）我们设立了个人信息保护责任人和机构，针对个人信息收集、使用、共享、委托处理等开展个人信息安全影响评估。您可以通过以下方式与我们联系，我们将在15天内答复您的请求：
      </p>
      <p class="sub_text">a)通过热线电话<span class="fontb">956025或者“在线客服”</span>与我们联系，客服会将相关事项转交给个人信息保护责任部门处理。</p>
      <p class="sub_text">b)<span class="fontb">个人信息保护责任部门负责人：王先生</span></p>
      <p class="sub_text">
        隐私保护邮箱:<a class="fontue">privacy@jtexpress.com</a>,
      </p>
      <p class="sub_text">
        或者寄信到<span class="fontb">上海市青浦区华新镇华隆路1777号A座9楼</span><span class="fontb">信息安全部门（收）</span></p>
      <p class="sub_text">邮编：<span class="fontb">201705</span>。
      </p>
      <p class="sub_text">
        5）我们不断吸收和借鉴国内外信息安全和隐私标准，我们按照ISO/IEC27001国际信息安全管理体系、ISO/IEC27701国际隐私信息管理体系、信息安全等级保护三级认证等国际及国内权威标准要求执行，同时我们也积极对标国内外个人信息和隐私保护法律法规，如国内个人信息安全规范GB/T35273，欧盟GDPR，持续改进我们的产品与/或服务安全、提升您的用户体验，保障您的隐私安全。
      </p>
      <p class="sub_text">
        6）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
      </p>
      <p class="sub_text">
        7）我们有责任和义务提醒您互联网并非绝对安全的环境，我们将尽力确保您发送给我们的任何信息的安全性。除不可抗力外，如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
      </p>
      <p class="sub_text">
        8）即便在我们执行了严格的保护措施的情况下，若不幸发生个人信息泄露事件，我们将按照相关法律法规的要求及时向您告知：个人信息泄露的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。同时，我们将及时通过电子邮件、信函、电话、或推送通知等方式告知您事件相关情况，难以逐一告知信息被泄露的主体时，我们会采取合理、有效的方式发布公告。我们还将按照监管部门要求，主动上报个人信息泄露事件的处置情况。
      </p>
      <p class="sub_text"><span class="fontb">四、我们如何使用您的信息</span></p>
      <p class="sub_text">1. 我们会根据本隐私指引的约定，为实现我们产品或服务功能对所收集的个人信息进行使用。</p>
      <p class="sub_text">2. 在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，我们针对这部分数据不会对外提供，也不会做任何商业化用途使用。</p>
      <p class="sub_text">
        3. 我们会采取去标识化方式对您的信息进行综合统计、分析加工，以便为您提供更加准确、流畅及便捷的服务，或帮助我们评估、改善或设计服务及运营活动等。
      </p>
      <p class="sub_text">4. 当我们展示您的个人信息时，我们会采用包括去标识化或匿名处理方式对您的信息进行处理，以保护您的信息安全。</p>
      <p class="sub_text">
        5. 当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，<span class="fontb"
          >会通过您的主动勾选或弹窗确认</span
        >的形式，事先征求您的同意。
      </p>
      <p class="sub_text"><span class="fontb">五、我们如何对外提供信息</span></p>
      <p class="sub_text"><span class="fontb">1.共享</span></p>
      <p class="sub_text">1）与授权合作伙伴共享：</p>
      <p class="sub_text">
        仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们只会共享提供服务所必要的个人信息，我们的合作伙伴无权将共享的个人信息用于任何其他用途。
      </p>
      <p class="sub_text">目前，我们的授权合作伙伴包括以下类型：</p>
      <p class="sub_text">
        供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式或潜在风险、运输、仓储、清关、末端收派、支付便利、提供客户服务、提供数据存储或数据分析服务、提供第三方附加业务功能服务（如语音输入、地图功能）或进行学术研究和调查。
      </p>
      <p class="sub_text">2）与我们的关联公司共享</p>
      <p class="sub_text">
        您的个人信息可能会与极兔的关联公司共享。我们只会共享必要的最小化个人信息，且受本政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
      </p>
      <p class="sub_text">
        我们承诺对您的信息进行严格保密，仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息，除法律法规及监管部门另有规定外。在共享您的个人信息前，我们会进行个人信息安全影响评估。
      </p>
      <p class="sub_text">
        同时我们会与上述供应商、服务提供商和其他合作伙伴的个人信息安全防护能力水平提出要求，签署严格的承诺书/保密协议/数据处理协议，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。一旦发现违反协议约定将会采取有效措施甚至终止合作。
      </p>
      <p class="sub_text">如您在使用过程中对我们使用的第三方服务和供应商有任何疑问，您可通过本政策中提供的联系方式与我们取得联系，我们会及时解答您的疑惑。</p>
      <p class="sub_text"><span class="fontb">2.转让</span></p>
      <p class="sub_text">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <p class="sub_text">1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
      <p class="sub_text">
        2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意；
      </p>
      <p class="sub_text">3）符合与您签署的相关协议（包括在线签署的电子协议）或其他的法律文件约定所提供；</p>
      <p class="sub_text">4）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供。</p>
      <p class="sub_text"><span class="fontb">3.公开披露</span></p>
      <p class="sub_text">我们仅会在以下情况下，公开披露您的信息</p>
      <p class="sub_text">1）如确需公开披露时，我们会向您告知公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明确同意。</p>
      <p class="sub_text">
        2）根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的信息，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
      </p>
      <p class="sub_text"><span class="fontb">4.委托处理</span></p>
      <p class="sub_text">
        为了更好的完成寄递服务，我们可能会委托关联公司（深圳云路信息科技有限公司，已获得信息安全管理体系ISO27001及个人信息安全管理体系ISO27701国际认证。）或其他专业机构代表我们来处理信息。我们会通过书面协议、现场审计等方式要求受托公司遵守严格的保密义务及采取有效的保密措施，禁止其将这些信息用于未经您授权的用途。受委托处理方包括：
      </p>
      <p class="sub_text">1）短信发送服务提供商；</p>
      <p class="sub_text">2）进出口清关服务提供商；</p>
      <p class="sub_text">3）转运服务提供商；</p>
      <p class="sub_text">4）地图服务提供商；</p>
      <p class="sub_text">5）网站/系统服务器托管服务提供商；</p>
      <p class="sub_text">6）寄递系统开发及运维商。</p>
      <p class="sub_text">
        在开展跨境寄递服务时，我们会事先开展数据出境安全评估，如涉及关联公司或第三方转运公司，我们将通过数据出境合同、数据跨境传输协议、数据处理协议等明确服务运营者及数据接收方的责任与义务，保障您的合法权益。确保您的个人信息与在境内的保护级别相同。
      </p>
      <p class="sub_text"><span class="fontb">5.共享、转让、公开披露个人信息时事先征得授权同意的例外</span></p>
      <p class="sub_text">以下情形中，我们共享、转让、公开披露个人信息不必事先征得您的授权同意：</p>
      <p class="sub_text">1）与履行法律法规规定的义务相关的；</p>
      <p class="sub_text">2）与国家安全、国防安全直接相关的；</p>
      <p class="sub_text">3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p class="sub_text">4）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
      <p class="sub_text">5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到 本人授权同意的；</p>
      <p class="sub_text">6）个人信息主体自行向社会公众公开的个人信息；</p>
      <p class="sub_text">7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
      <p class="sub_text"><span class="fontb">六、您如何访问和管理自己的信息</span></p>
      <p class="sub_text"><span class="fontb">1.访问您的个人信息</span></p>
      <p class="sub_text">您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：</p>
      <p class="sub_text">1）账户信息</p>
      <p class="sub_text">
        如果您希望访问您的账户中的个人资料信息，您可以使用账号和密码或通过第三方授权，登录我们的小程序在<span class="fontb">“个人设置”</span
        >中查看绑定的手机号码，通过<span class="fontb">“我的”-“实名登记”</span>中查看其他信息。这些信息我们将脱敏展示。
      </p>
      <p class="sub_text">2）寄件记录和交易记录</p>
      <p class="sub_text">您可以使用账号和密码或通过第三方授权，登录我们的小程序在<span class="fontb">“查件”</span>中查询。</p>
      <p class="sub_text">3）寄件、收件信息</p>
      <p class="sub_text">
        您可以使用账号和密码或通过第三方授权，登录我们的小程序在<span class="fontb">“我的”-“地址薄”</span
        >中查询或新增寄件人和收件人的姓名、手机号码、寄递件地址。
      </p>
      <p class="sub_text">
        如您需要访问您在使用我们的产品与/或服务过程中产生的其他个人信息，您可以通过本隐私政策所列明的联系方式与我们联系，我们会在十五个工作日内响应您的请求。
      </p>
      <p class="sub_text"><span class="fontb">2.更正您的个人信息</span></p>
      <p class="sub_text">
        当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“<span class="fontb">1.访问您的个人信息</span
        >”中罗列的方式更正您的个人信息。
      </p>
      <p class="sub_text">如您需要更正您在使用我们的产品与/或服务过程中产生的其他个人信息，如修改派送地址、联系电话，您可以与我们的客服联系。</p>
      <p class="sub_text"><span class="fontb">3.删除您的个人信息</span></p>
      <p class="sub_text">您可以在以下情形中，向我们提出删除个人信息的请求：</p>
      <p class="sub_text">1）如果我们处理个人信息的行为违反法律法规；</p>
      <p class="sub_text">2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>
      <p class="sub_text">3）如果我们处理个人信息的行为违反了与您的约定；</p>
      <p class="sub_text">4）如果您不再使用我们的产品与/或服务，或您注销了账号；</p>
      <p class="sub_text">5）如果我们不再为您提供产品与/或服务。</p>
      <p class="sub_text">
        也可以通过“<span class="fontb">1.访问您的个人信息</span>”中罗列的方式删除您的<span class="fontb">实名制信息、寄递记录、寄递人信息</span>。
      </p>
      <p class="sub_text">在满足法律法规的要求的前提下，我们将响应您的请求，对个人信息进行完全删除。</p>
      <p class="sub_text"><span class="fontb">4.撤回您的同意</span></p>
      <p class="sub_text">对于额外（见本政策“3、实现业务附加功能所收集的场景”）收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。</p>
      <p class="sub_text">
        1）您可以通过小程序<span class="fontb">“设置”-“订阅消息”</span>拒绝接收通知；<span class="fontb">“设置”-“位置信息”</span>选择<span class="fontb"
          >“不允许”</span
        >或<span class="fontb">“仅在使用小程序期间”</span>；
      </p>
      <p class="sub_text">
        2）还可以通过小程序<span class="fontb">“设置”-“已获取的信息”，</span>通过<span class="fontb">“管理”</span>通知我们在24小时内删除<span class="fontb"
          >“选中的照片或视频”</span
        >及<span class="fontb">“手机号”。</span>
      </p>
      <p class="sub_text">另外您也可以通过注销账号的方式，撤回我们继续收集您个人信息的全部授权。</p>
      <p class="sub_text">3）当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
      <p class="sub_text">
        4）当您收到我们发送的短信时，可以根据信息中的退订提示<span class="fontb">（如“回复TD退订”）</span>，要求不再向您发送短信，我们会尊重您的请求。
      </p>
      <p class="sub_text"><span class="fontb">5.携带您个人信息</span></p>
      <p class="sub_text">
        您可以通过热线电话<span class="fontb">956025</span>与我们联系，在通过必要的验证措施后，在法律法规允许的情况下将您的个人信息发送您至指定的邮箱。
      </p>
      <p class="sub_text"><span class="fontb">你可以拨打</span></p>
      <p class="sub_text"><span class="fontb">6.注销您的账户</span></p>
      <p class="sub_text">
        您可以通过登录小程序，根据<span class="fontb">“我的”-“注销账号”</span
        >路径提交注销账户的请求。我们会提供注销协议，告知您执行注销操作可能造成的影响，当您继续选择注销我们的账户时，我们将对您的权益及信息设置<span
          class="fontb"
          >三十天</span
        >的注销删除等待期，在提交注销申请后的等待期内可撤销申请，并可通过重新注册复原相关个人账号信息和相关个人服务记录，超过等待期将根据法律法规删除或匿名化处理。
      </p>
      <p class="sub_text"><span class="fontb">7.响应您的上述请求</span></p>
      <p class="sub_text">为保障安全，对于您部分上述请求，我们可能会先要求您验证自己的身份，然后再处理您的请求。对于您的请求我们将在十五个工作日内做出答复。</p>
      <p class="sub_text">
        对于合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
      </p>
      <p class="sub_text"><span class="fontb">8.我们无法响应您请求的情形</span></p>
      <p class="sub_text">1）与我们履行法律法规规定的义务相关的；</p>
      <p class="sub_text">2）与国家安全、国防安全直接相关的；</p>
      <p class="sub_text">3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p class="sub_text">4）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
      <p class="sub_text">5）个人信息控制者有充分证据表明您存在主观恶意或滥用权利的；</p>
      <p class="sub_text">6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p class="sub_text">7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
      <p class="sub_text">8）涉及商业秘密的。</p>
      <p class="sub_text"><span class="fontb">七、我们如何处理儿童的个人信息</span></p>
      <p class="sub_text">1、我们的产品与/或服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的个人信息主体账户。</p>
      <p class="sub_text">
        2、对于经监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、监护人明确同意或者保护儿童所必要的情况下收集、存储、使用、共享、转让、公开披露此信息。
      </p>
      <p class="sub_text">3、本隐私政策所称儿童为不满十四周岁的未成年人。</p>
      <p class="sub_text">4、如果有事实证明儿童并未取得监护人同意的情况下注册使用了我们的产品与/或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。</p>
      <p class="sub_text"><span class="fontb">八、您的个人信息如何在全球范围转移</span></p>
      <p class="sub_text">原则上，我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中华人民共和国境内。</p>
      <p class="sub_text">
        如您选择我们的国际件服务，我们会通过将国际件运单信息传输给您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。此外，为实现本政策所声明的其他目的，您的个人信息亦可能被传输到您使用产品或服务所在国家/地区的境外管辖区。
      </p>
      <p class="sub_text">
        此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在原始收集国/地区境内足够同等的保护。例如，运单信息采取加密传输、定期评估审计接收方的安全能力水平、签订数据处理协议/条款。
      </p>
      <p class="sub_text"><span class="fontb">九、本指引的修订及更新</span></p>
      <p class="sub_text">本隐私政策可能会发生变更。未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</p>
      <p class="sub_text">
        对于重大变更，我们会通过网站公告或以其他适当方式（例如：电子邮件、信函、电话、或推送通知等方式）提醒您相关内容的更新，也请您访问极兔以便及时了解最新的隐私政策。
      </p>
      <p class="sub_text">本政策所指的重大变更包括但不限于：</p>
      <p class="sub_text">1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
      <p class="sub_text">2、我们在所有权结构、组织架构等方面发生重大变化。如企业破产、被兼并、收购等情况；</p>
      <p class="sub_text">3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
      <p class="sub_text">4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
      <p class="sub_text">5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
      <p class="sub_text">6、个人信息安全影响评估报告表明存在高风险时。</p>
      <p class="sub_text"><span class="fontb">十、其他事宜</span></p>
      <p class="sub_text">本指引涉及内容遵照本指引执行，未尽事宜遵照您申请开户时签订的《用户服务协议》中相关条款执行。</p>
      <p class="sub_text">
        当自然人主体死亡时，如其近亲属为了自身的合法、正当利益，我们将配合其近亲属对死者的个人信息行使查阅、复制、更正、删除等权利，死者生前另有安排的除外。
      </p>
      <p class="sub_text">隐私政策历史版本参考：</p>
      <p class="sub_text">极兔隐私政策（发布日期：2021年7月1日）<a></a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Oldprivacy',
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>

<style scoped lang="scss">
$color999: #999999;
$color333: #333333;
.pages {
  background: #ffffff;
  box-sizing: border-box;
  padding: 16px;
  font-size: 14px;
  color: $color333;
}
.fontb {
  font-weight: bold;
  color: $color333;
  font-size: 14px;
}
.fontue {
  font-weight: bold;
  color: blue;
  font-size: 14px;
  display: inline-block;
  text-decoration: underline;
}
.title {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
}
.sub_title {
  font-size: 14px;
  padding: 5px;
  text-align: center;
}
.sub_title_1 {
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 5px;
  padding-top: 5px;
}
.pt10 {
  padding-top: 5px;
}
.sub_text {
  font-size: 14px;
  line-height: 18px;
  text-align: left;
  margin-bottom: 4px;
}
.text_indent {
  text-indent: 27px;
}
.pt30 {
  padding-top: 16px;
}
.btd {
  margin-bottom: 10px;
}
.one {
  margin: 10px 0;
}
</style>
